import { IMenu, IMenuFilterArgsType } from "@airborne/react-admin";
import { OwnerTypeDesc } from "./Enums/OwnerTypes";

export const MenuFilters = menuFilterValue => {
  const filterMenu = ({ menu, user }: IMenuFilterArgsType): IMenu => {
    for (let i = 0; i < menu.length; i++) {
      const element = menu[i];
      element.children = element.children?.filter(x => x.text.toLowerCase().includes(menuFilterValue.toLowerCase()));
    }
    menu = menu.filter((x: any) => x?.children?.length != 0);
    return menu;
  };

  const internalFilter = ({ menu, user }: IMenuFilterArgsType): IMenu =>
    menu.filter(menuItem => (user.isCustomer === false ? menuItem?.isVisibleForInternal !== false : true));

  const unauthorizedFilter = ({ menu, user }: IMenuFilterArgsType): IMenu => {
    var filteredMenu = menu.filter(x => (x.unauthorizedRoles?.some?.(k => user.roles.includes(k)) ? false : true));
    return filteredMenu;
  };
  const ownerFilter = ({ menu, user }: IMenuFilterArgsType): IMenu => {
    var ownerValue = OwnerTypeDesc.find(x => x.Description == user?.ownerCode)?.Value;
    //ownersFilter alanı doldurulmuşsa, o ownerlara ait userlar bu menuyu görecektir
    var filteredMenu = menu.filter(
      x => !user.isCustomer || !x.ownersFilter || x.ownersFilter?.some?.(k => k == ownerValue)
    );
    return filteredMenu;
  };
  return [filterMenu, internalFilter, unauthorizedFilter, ownerFilter];
};
